import { logError } from '@lib/logger/logError';
import { extractErrorMessage } from '@lib/logger/extractErrorMessage';
import { type ApiResponse } from '@types';

export const handleApiError = <T = never>(
  message: string,
  error: unknown,
  source: string,
): ApiResponse<T> => {
  const raw = extractErrorMessage(error);

  void logError(message, source, { rawError: error, error: raw }, false);

  return {
    success: false,
    error: { message, raw },
  };
};
